module.exports = __webpack_public_path__ + "img/source1_3.b7072b6a.png";